/* rrd-search.js (post-live search, 11 Oct 2026). Layout glue around Dawn's <predictive-search> (keys and fetching stay in
   assets/predictive-search.js):
   desktop: places the results panel under the field (860px, kept inside the viewport), dims the page below the header while
            results are open, closes results when a mega menu opens or the field scrolls away;
   sheet:   keeps Tab inside the open phone sheet using the elements visible now (Dawn's trap only knows the elements that
            existed when it opened) and pulls stray focus back. */
(function () {
  'use strict';
  function desktop(wrap) {
    var box = wrap.querySelector('predictive-search'), field = wrap.querySelector('.rs-f');
    if (!box || !field) return;
    var nav = wrap.closest('.rrd-nav'), r3 = nav && nav.querySelector('.rn-r3');
    var dim = document.createElement('div');
    dim.className = 'rs-dim'; dim.setAttribute('aria-hidden', 'true');
    (nav || document.body).appendChild(dim);
    var raf = 0;
    function place() {
      raf = 0;
      var vw = document.documentElement.clientWidth, fr = field.getBoundingClientRect(), w = Math.min(860, vw - 48), l = 0;
      if (fr.left + w > vw - 24) l = vw - 24 - w - fr.left;
      if (fr.left + l < 24) l = 24 - fr.left;
      wrap.style.setProperty('--rs-w', Math.round(w) + 'px');
      wrap.style.setProperty('--rs-l', Math.round(l) + 'px');
      wrap.style.setProperty('--rs-mh', Math.max(240, Math.round(window.innerHeight - fr.bottom - 24)) + 'px');
      var hb = (nav || wrap).getBoundingClientRect().bottom;
      dim.style.top = Math.max(0, Math.round(hb)) + 'px';
    }
    function sched() { if (!raf) raf = requestAnimationFrame(place); }
    function sync() {
      var on = box.hasAttribute('open');
      if (on) place();
      if (nav) nav.classList.toggle('rs-on', on);
      dim.classList.toggle('is-on', on);
    }
    new MutationObserver(sync).observe(box, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('resize', function () { if (box.hasAttribute('open')) sched(); }, { passive: true });
    window.addEventListener('scroll', function () {
      if (!box.hasAttribute('open')) return;
      if (field.getBoundingClientRect().bottom < 0) { box.close(); return; }
      sched();
    }, { passive: true });
    // a click in the already-focused field reopens results that a mega menu or Escape closed
    var input = wrap.querySelector('input[type="search"]');
    if (input) input.addEventListener('click', function () {
      if (!box.hasAttribute('open') && input.value.trim().length && box.getAttribute('results') === 'true' && typeof box.open === 'function') box.open();
    });
    if (r3) new MutationObserver(function () {
      if (box.hasAttribute('open') && r3.querySelector('.rn-it.is-open')) box.close();
    }).observe(r3, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select,textarea,[tabindex]';
  function tabbables(root) {
    return [].filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null;
    });
  }
  function sheet(dm) {
    var det = dm.querySelector('details'), sh = dm.querySelector('.rs-sheet');
    if (!det || !sh) return;
    sh.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !det.hasAttribute('open')) return;
      e.stopPropagation(); // Dawn's document-level trap would act on stale first/last elements
      var f = tabbables(sh); if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || f.indexOf(a) === -1 && !(last.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_FOLLOWING))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || f.indexOf(a) === -1 && (last.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_FOLLOWING))) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('focusin', function (e) {
      if (!det.hasAttribute('open') || dm.contains(e.target)) return;
      var f = tabbables(sh); if (f.length) f[0].focus();
    });
  }
  function init() {
    [].forEach.call(document.querySelectorAll('[data-rrd-search="desktop"]'), desktop);
    [].forEach.call(document.querySelectorAll('[data-rrd-search="sheet"]'), sheet);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
